module.exports = __webpack_public_path__ + "static/media/amenity-hair-dresser.a9902a65.svg";